import { render } from "./superturbo_designer.vue?vue&type=template&id=3f3be148"
import script from "./superturbo_designer.vue?vue&type=script&lang=js"
export * from "./superturbo_designer.vue?vue&type=script&lang=js"

import "./superturbo_designer.vue?vue&type=style&index=0&id=3f3be148&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__